'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyMachine = require('@metaplex-foundation/mpl-candy-machine');
var gpaBuilders = require('./gpaBuilders.cjs');

/** @group Programs */
const CandyMachineV2Program = {
  publicKey: mplCandyMachine.PROGRAM_ID,
  accounts(metaplex) {
    return new gpaBuilders.CandyMachineV2GpaBuilder(metaplex, this.publicKey);
  }
};

exports.CandyMachineV2Program = CandyMachineV2Program;
//# sourceMappingURL=program.cjs.map
